import React, { useState, useEffect } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Button, TextField } from "react-md";
import PropTypes from "prop-types";

import MCard from "components/Shared/MCard.tsx";
import { MSpinner } from "components/Shared";

const COMMENT_DIRECTION_QA = "COMMENT_DIRECTION_QA";
const COMMENT_DIRECTION_APPRAISER = "COMMENT_DIRECTION_APPRAISER";

const AppraiserCaseIssueFields = (props) => {
  const [caseIssueOptions, setCaseIssueOptions] = useState(null);

  const { caseIssues, caseIssueTypes, updateIssues, commentDirection, makeToast } = props;

  useEffect(() => {
    if (!caseIssueOptions) {
      setCaseIssueOptions(mapCaseIssues());
    }
  }, []);

  const trySave = () => {
    if (missingComments()) {
      makeToast("Please fill out comments for checked issues");
    } else {
      let issuesToMap = [];
      for (const issues in caseIssueOptions) {
        caseIssueOptions[issues].filter(s => s.checked || s.appraiserResolved).forEach(s =>
          issuesToMap.push({
            id: s.id,
            name: s.name,
            code: s.value,
            qualityAssuranceResponse: s.qualityAssuranceResponse,
            appraiserResponse: s.appraiserResponse,
            appraiserResolved: s.appraiserResolved,
            active: s.checked
          }));
      }
      updateIssues(issuesToMap);
    }
  };

  const mapCaseIssues = () => {
    let issueGroups = [];
    caseIssueTypes.forEach(s => {
      if (!issueGroups[s.displayGroup]) {
        issueGroups[s.displayGroup] = [];
      }
      let currIssue = caseIssues.filter(p => p.code === s.code)[0];
      issueGroups[s.displayGroup].push({
        id: currIssue?.id,
        name: s.name,
        value: s.code,
        checked: currIssue?.active,
        resolved: currIssue?.appraiserResolved,
        appraiserResponse: currIssue?.appraiserResponse,
        qualityAssuranceResponse: currIssue?.qualityAssuranceResponse
      });
    });
    return issueGroups;
  };

  const handleIssueChecked = (event, code, group) => {
    let issues = { ...caseIssueOptions };
    issues[group].filter(s => s.value === code)[0].checked = event.target.checked;
    setCaseIssueOptions(issues);
  };

  const handleResolvedChecked = (event, code, group) => {
    let issues = { ...caseIssueOptions };
    issues[group].filter(s => s.value === code)[0].appraiserResolved = event.target.checked;
    setCaseIssueOptions(issues);
  };

  const setQualityAssuranceComments = (event, code, group) => {
    let issues = { ...caseIssueOptions };
    issues[group].filter(s => s.value === code)[0].qualityAssuranceResponse = event.target.value;
    setCaseIssueOptions(issues);
  };

  const setAppraiserComments = (event, code, group) => {
    let issues = { ...caseIssueOptions };
    issues[group].filter(s => s.value === code)[0].appraiserResponse = event.target.value;
    setCaseIssueOptions(issues);
  };

  const missingComments = () => {
    for (const issue of Object.entries(caseIssueOptions)) {
      let checked = caseIssueOptions[issue[0]].filter(s => s.checked);
      let missing = checked.map(s =>
        commentDirection === COMMENT_DIRECTION_QA
          ? s.qualityAssuranceResponse && s.qualityAssuranceResponse.length ? false : true
          : commentDirection === COMMENT_DIRECTION_APPRAISER
            ? s.appraiserResponse && s.appraiserResponse.length ? false : true
            : false
      );
      if (missing.some(s => s)) {
        return true;
      }
    }
  };

  const getFields = () => {
    let issueGroups = [];
    for (let s in caseIssueOptions) {
      issueGroups.push(shapeIssueGroup(caseIssueOptions[s], s));
    }
    const caseIssueSave = (
      <div className={"save-control"}>
        <Button primary raised onClick={() => trySave()}>Save</Button>
      </div>
    );
    return (
      [{
        key: "issues", control: (
          <>
            {issueGroups}
            {caseIssueSave}
          </>
        )
      }]
    );
  };

  const shapeIssueGroup = (issueGroup, groupName) => {
    return (
      <div key={groupName}>
        <div><b><u>{groupName}</u></b></div>
        <FormGroup>
          {issueGroup.map(s => (
            <span key={s.value} style={{ display: "flex" }}>
              <FormControlLabel
                style={{ width: "20%", wordBreak: "break-all" }}
                control={
                  <Checkbox
                    checked={s.checked}
                    onChange={event => handleIssueChecked(event, s.value, groupName)}
                    value={s.value}
                    color="primary"
                  />
                }
                label={s.name}
              />
              <TextField
                style={{ width: "35%", paddingRight: "10px", wordBreak: "break-all" }}
                id="floating-center-title-qa"
                label="Quality Assurance Comments"
                defaultValue={s.qualityAssuranceResponse}
                onBlur={event => setQualityAssuranceComments(event, s.value, groupName)}
                disabled={commentDirection !== COMMENT_DIRECTION_QA}
                required={s.checked}
                rows={3}
              />
              <TextField
                style={{ width: "35%", paddingRight: "40px", wordBreak: "break-all" }}
                id="floating-center-title-app"
                label="Appraiser Comments"
                defaultValue={s.appraiserResponse}
                onBlur={event => setAppraiserComments(event, s.value, groupName)}
                disabled={commentDirection !== COMMENT_DIRECTION_APPRAISER}
                required={s.checked}
                rows={3}
              />
              <FormControlLabel
                style={{ width: "10%", overflow: "auto" }}
                key={`${s.value}_resolved`}
                disabled={commentDirection !== COMMENT_DIRECTION_APPRAISER}
                control={
                  <Checkbox
                    checked={s.resolved}
                    onChange={event => handleResolvedChecked(event, s.value, groupName)}
                    value={`${s.value}_resolved`}
                    color="primary"
                  />
                }
                label={"Appraiser Resolved"}
              />
            </span>
          ))}
        </FormGroup>
      </div>
    );
  };

  if (!caseIssueOptions) {
    return (<MSpinner />);
  }
  return (
    <MCard
      title="Case Issues"
      className="qa-case-issues"
      fields={getFields()}
    />
  );
};

AppraiserCaseIssueFields.propTypes = {
  caseIssues: PropTypes.array,
  caseIssueComments: PropTypes.string,
  caseIssueTypes: PropTypes.array,
  updateIssues: PropTypes.func,
  commentDirection: PropTypes.string,
  makeToast: PropTypes.func,
};

export default AppraiserCaseIssueFields;